import React, { useEffect } from "react";
import { useRoutes } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import JSONForm from "./JSONForm";
import { PageProps, Pages } from "./types/Pages";
import {
  getFedsConfig,
  loadExternalFiles,
  mergeUiSchema,
  addCommonComponent,
} from "./utils/commonUtils";

function PageRoutes({
  pages: multiplePages,
  storybook,
  renderers,
  lifecycleHooks,
  includeAdvancedRenderers,
  commonJsonHeaders,
}: PageProps) {
  const pages = multiplePages as Pages;
  const allPages = pages.elements;
  const header = pages?.options?.header;
  const footer = pages?.options?.footer;
  const container = pages?.options?.container;
  const gNavFromContext = useSelector((state: any) => state?.reduxState?.gNav);
  const fedsConfig = gNavFromContext || getFedsConfig(pages);
  let config: any = { ...pages?.config, lifecycleHooks, fedsConfig };
  const components = pages?.options?.components;

  const external = pages?.options?.external;

  useEffect(() => {
    if (external) {
      loadExternalFiles(external);
    }
  }, [external]);

  if (storybook) {
    const uiWithCommonComponent = addCommonComponent(
      allPages[0]?.options.uischema,
      components
    );
    const updatedUiSchema = mergeUiSchema(
      uiWithCommonComponent,
      header,
      footer,
      container
    );

    const commonTranslations = commonJsonHeaders?.translations;
    const pageTranslations = allPages[0]?.options?.translations;
    const combinedTranslations = _.mergeWith(
      commonTranslations,
      pageTranslations
    );
    config = { ...config, translations: combinedTranslations };

    return (
      <JSONForm
        schema={allPages[0]?.options?.schema}
        uischema={updatedUiSchema}
        data={allPages[0]?.options?.data}
        config={config}
        renderers={renderers}
        authenticated={allPages[0]?.options?.authenticated}
        includeAdvancedRenderers={includeAdvancedRenderers}
      />
    );
  }

  const routes = useRoutes(
    allPages.map((page) => {
      const {
        schema,
        uischema,
        data,
        path = "",
        authenticated = false,
      } = page.options;
      const uiWithCommonComponent = addCommonComponent(uischema, components);
      const updatedUiSchema = mergeUiSchema(
        uiWithCommonComponent,
        header,
        footer,
        container
      );

      const commonTranslations = commonJsonHeaders?.translations;
      const pageTranslations = page?.options?.translations;
      const combinedTranslations = _.mergeWith(
        commonTranslations,
        pageTranslations
      );
      config = { ...config, translations: combinedTranslations };

      return {
        path,
        element: (
          <JSONForm
            schema={schema}
            uischema={updatedUiSchema}
            data={data}
            config={config}
            authenticated={authenticated}
            renderers={renderers}
            includeAdvancedRenderers={includeAdvancedRenderers}
          />
        ),
      };
    })
  );
  return <div>{routes}</div>;
}

export default PageRoutes;
